"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var react_1 = __importDefault(require("react"));

var StyledImageInformation = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  background-color: rgba(0, 0, 0, 0.4);\n  color: #fff;\n  padding: 2px 4px;\n  border-radius: 2px;\n  font-size: 12px;\n"], ["\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  background-color: rgba(0, 0, 0, 0.4);\n  color: #fff;\n  padding: 2px 4px;\n  border-radius: 2px;\n  font-size: 12px;\n"])));

exports.ImageInformation = function (_a) {
  var image = _a.image;
  return image ? react_1.default.createElement(StyledImageInformation, null, image.mimeType ? react_1.default.createElement("div", null, image.mimeType) : null, image.name ? react_1.default.createElement("div", null, image.name) : null, image.id ? react_1.default.createElement("div", null, image.id) : null, image.size ? react_1.default.createElement("div", null, image.size > 1048576 ? Math.round(image.size / 1048576) + ' MB' : image.size > 1024 ? Math.round(image.size / 1024) + ' kB' : image.size + ' B') : null, image.provider ? react_1.default.createElement("div", null, image.provider) : null, image.author ? react_1.default.createElement("div", null, image.author) : null) : null;
};

var templateObject_1;